import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogTitle
} from "@mui/material";
import "./EventType.css";
import megaPhoneIcon from "../../../../assets/megaphone.svg";

export default function EventType({
    isOpen,
    onClose,
    onSelect,
    PaperProps,
    
}) {
    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            maxWidth="md"

            PaperProps={{
                component: "form",
                className: `event-type-modal sm`,
                ...PaperProps // Spread the PaperProps
            }}


        >
            <DialogTitle sx={{ padding: "0.1875rem 1.125rem" }}>
                <div className="title-dialog">
                    <span class="material-symbols-outlined event-type-icon-title">
                        calendar_today
                    </span>
                    <div>
                        <h2>
                            Créer un événement
                        </h2>
                        <p>
                            Quel type d’événement souhaitez-vous organiser dans la salle Innovation ?
                        </p>
                    </div>
                    <span className="material-symbols-outlined cursor-pointer event-type-close" onClick={onClose}>
                        close
                    </span>
                </div>
            </DialogTitle>


            <DialogContent>
                <div className='event-type-item event-type-1' onClick={() => onSelect("scheduled_meeting")}>
                    <div className='event-type-item-body'>
                        <div className='event-type-item-icon'>
                            <span class="material-symbols-outlined">
                                calendar_month
                            </span>
                        </div>
                        <div className='event-type-item-details'>
                            <span>Réunion planifiée</span>
                            <p>
                                Planifiez une réunion avec des invités internes et externes. Définissez la date, l’heure et envoyez des rappels.
                            </p>
                        </div>
                    </div>
                    <div className='event-type-item-tags'>
                        <span className='event-tag-type'>Date & heure</span>
                        <span className='event-tag-type'>Invités</span>
                        <span className='event-tag-type'>Rappels</span>
                    </div>
                </div>

                <div className='event-type-item event-type-2' onClick={() => onSelect("conference")}>
                    <div className='event-type-item-body'>
                        <div className='event-type-item-icon'>
                            <span class="material-symbols-outlined">
                                <img src={megaPhoneIcon} />
                            </span>
                        </div>
                        <div className='event-type-item-details'>
                            <span>Conférence</span>
                            <p>
                                Organisez une session avec droits avancés: micro, caméra, partage écran, rôle master. Vous pouvez également partager l'inscription à cette conférence à l'extérieur.
                            </p>
                        </div>
                    </div>
                    <div className='event-type-item-tags'>
                        <span className='event-tag-type'>Droits participants</span>
                        <span className='event-tag-type'>Masters</span>
                        <span className='event-tag-type'>Règles</span>
                    </div>
                </div>

            </DialogContent>

        </Dialog>
    );
}
